import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { StepTask } from '@telespot/domain';
import { LocalizedName } from '@protocols/domain';

export interface PipelineStepCompatibilityInfo {
  outputLabels: Set<string>;
  outputLabelNames: Record<string, LocalizedName>;
  task: StepTask;
}

interface PipelineStepDetailStateModel {
  compatibilityInfo: PipelineStepCompatibilityInfo | undefined;
  error: string | null;
}

const INITIAL_STATE: PipelineStepDetailStateModel = {
  compatibilityInfo: undefined,
  error: null,
};

@Injectable()
export class PipelineStepDetailState extends ComponentStore<PipelineStepDetailStateModel> {
  constructor() {
    super({ ...INITIAL_STATE });
  }

  // ============================================================================
  // Selectors
  // ============================================================================

  public readonly compatibilityInfo$ = this.select((state) => state.compatibilityInfo);
  public readonly error$ = this.select((state) => state.error);

  // ============================================================================
  // Updaters
  // ============================================================================

  public readonly setStep = this.updater((state, step: PipelineStepCompatibilityInfo) => ({
    compatibilityInfo: { outputLabels: step.outputLabels, outputLabelNames: step.outputLabelNames, task: step.task },
    error: null,
  }));

  public readonly setError = this.updater((state, error: string | null) => ({ ...state, error }));

  public readonly reset = this.updater(() => ({ ...INITIAL_STATE }));
}
